import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Home from '@/components/Home'
import {formatVueUrl, isNotEmpty} from "@/utils/common";

Vue.use(Router)
let fixHomeRoutes = ['/public/upload', '/dashboard']
let asyncRoutes = [
  {
    path: '/',
    name: 'Login',
    component: Login
  }, {
    path: '/home',
    name: 'home',
    component: Home,
    redirect: '/Dashboard',
    meta: {
      requireAuth: true//添加权限访问，表示只有登录之后才能进行该操作
    },
    children: []
  }
]
export default new Router({
  routes: asyncRoutes
})

const originalPush = Router.prototype.push

Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}


Router.prototype.loadPage = function (menuList) {
  // this.matcher = new Router({routes: asyncRoutes}).matcher
  menuList.forEach(item => {
    if (!item) {
      return
    }

    let routerPath = formatVueUrl(item["path"])
    if (isNotEmpty(routerPath)&&item.type!=2) {
      this.addRoute('home', {
        path: '/' + routerPath,
        name: routerPath,
        component: () => (import ('@/components/' + routerPath + '.vue'))
          .catch(e => {
            console.log("加载路由错误:", routerPath)
          })
      })
    }
  })

  fixHomeRoutes.forEach(item => {
    item = formatVueUrl(item)
    this.addRoute('home', {
      path: '/' + item,
      name: item,
      component: () => (import ('@/components/' + item + '.vue'))
        .catch(e => {
          console.log("加载路由错误:", item)
        })
    })
  })

  //添加404
  this.addRoute({
    path: '/*',
    component: () => import('@/components/404.vue')
  })


  return menuList
}



// WEBPACK FOOTER //
// ./src/router/index.js